import * as React from "react";
import {getAccessToken, GlobalContext} from "../state/GlobalProvider";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import QQCatalyst from "./qqcatalyst";
import CenteredNotification from "../util/CenteredNotification";
import {Alert, AlertDescription, AlertTitle} from "@/components/ui/alert";
import {ExclamationTriangleIcon, InfoCircledIcon} from "@radix-ui/react-icons";
import Calls from "./calls";


export default function MainLayout() {

    const [ init, setInit ] = React.useState(false);
    const { updateAuth, auth } = React.useContext(GlobalContext);

    // On first load try to get a token
    React.useEffect(() => {
        (async () => {
            try {
                let token = await getAccessToken();
                updateAuth(token);
            } catch (e) {
                /* Ignore errors on load */
            }
            setInit(true);

        })();
    }, [updateAuth, setInit]);

    if (!init) {
        return <></>
    }

    if (!auth.token) {
        return (
            <CenteredNotification>
                <Alert variant="destructive">
                    <ExclamationTriangleIcon className="h-4 w-4" />
                    <AlertTitle>Not logged in</AlertTitle>
                    <AlertDescription>
                        You must be signed in to access this integration.
                    </AlertDescription>
                </Alert>
            </CenteredNotification>
        );
    }

    return (
        <Router>
            <Routes>
                <Route
                    path="/"
                    element={
                        <CenteredNotification>
                            <Alert>
                                <InfoCircledIcon className="h-4 w-4" />
                                <AlertTitle>No integration selected</AlertTitle>
                                <AlertDescription>
                                    Open this app from an integration link.
                                </AlertDescription>
                            </Alert>
                        </CenteredNotification>
                    }
                />
                <Route path="/qqcatalyst/*" element={<QQCatalyst />} />
                <Route path="/calls/*" element={<Calls />} />
            </Routes>
        </Router>
    );
}
